import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { JD_MESSAGE_DEFAULT_CONFIG_PROVIDER } from './message-config';
import { JdMessageContainerComponent } from './jd-message-container.component';
import { JdMessageComponent } from './message.component';
import { JdMessageService } from './message.service';
import {MatIconModule} from '@angular/material';

@NgModule({
  imports: [ CommonModule, OverlayModule, MatIconModule ],
  declarations: [ JdMessageContainerComponent, JdMessageComponent ],
  providers: [ JD_MESSAGE_DEFAULT_CONFIG_PROVIDER, JdMessageService ],
  entryComponents: [ JdMessageContainerComponent ]
})
export class JdMessageModule { }
